import React, { createContext, useReducer, ReactNode } from 'react';
import { initialState, reducers } from './state';
import { AppContextType, RootState } from '../types';

export const AppContext = createContext<AppContextType>({
  state: initialState,
  dispatch: () => undefined,
});

interface AppContextProviderProps {
  children: ReactNode;
}

export const AppContextProvider: React.FC<AppContextProviderProps> = ({ children }) => {
  const [store, dispatch] = useReducer(reducers, initialState);

  const contextValue: AppContextType = {
    state: store as RootState,
    dispatch: dispatch as AppContextType['dispatch'],
  };

  return <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>;
};
